// src/utils/pushNotifications.js
// Notificări de tip telefon / push folosind Notification API a browser-ului.
// Nu depinde de un serviciu extern (VAPID/Service Worker); afișează notificări
// native atunci când apar notificări noi cât timp aplicația este deschisă.

const STORAGE_KEY = "__push_notifications_enabled__";

export function isPushSupported() {
   return typeof window !== "undefined" && "Notification" in window;
}

export function getPushPermission() {
   if (!isPushSupported()) return "unsupported";
   return Notification.permission; // "default" | "granted" | "denied"
}

export function isPushEnabled() {
   if (!isPushSupported()) return false;
   if (Notification.permission !== "granted") return false;
   try {
      // Implicit activat după ce userul a acordat permisiunea, dar respectăm
      // preferința salvată dacă a dezactivat manual.
      return localStorage.getItem(STORAGE_KEY) !== "0";
   } catch {
      return true;
   }
}

export function setPushEnabledPreference(enabled) {
   try {
      localStorage.setItem(STORAGE_KEY, enabled ? "1" : "0");
   } catch {}
}

/**
 * Cere permisiunea pentru notificări push (trebuie apelat dintr-un gest al
 * utilizatorului – click pe buton). Returnează permisiunea rezultată.
 */
export async function requestPushPermission() {
   if (!isPushSupported()) return "unsupported";
   if (Notification.permission === "granted") {
      setPushEnabledPreference(true);
      return "granted";
   }
   if (Notification.permission === "denied") return "denied";

   try {
      const result = await Notification.requestPermission();
      if (result === "granted") setPushEnabledPreference(true);
      return result;
   } catch {
      return Notification.permission;
   }
}

/**
 * Afișează o notificare push nativă. Silent no-op dacă nu e permis/suportat.
 */
export function showPushNotification({ title, body, tag, data } = {}) {
   if (!isPushEnabled()) return null;
   // Nu deranja userul dacă e deja pe pagină și tab-ul e vizibil.
   if (
      typeof document !== "undefined" &&
      document.visibilityState === "visible"
   ) {
      return null;
   }

   try {
      const notification = new Notification(String(title || "Notificare"), {
         body: body ? String(body) : undefined,
         tag: tag ? String(tag) : undefined,
         icon: "/logo192.png",
         badge: "/logo192.png",
         data: data || undefined,
      });

      notification.onclick = () => {
         try {
            window.focus();
         } catch {}
         notification.close();
      };

      return notification;
   } catch {
      return null;
   }
}
